import PropTypes from 'prop-types';
import { INVITATION_TYPES } from '../lib/invitations';

export const historyPropType = PropTypes.shape({
  push: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
});

export const locationPropType = PropTypes.shape({
  pathname: PropTypes.string.isRequired,
  state: PropTypes.shape({}),
});

export const matchPropType = PropTypes.shape({
  isExact: PropTypes.bool.isRequired,
  params: PropTypes.shape({}).isRequired,
});

export const birthdayPropType = PropTypes.shape({
  day: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  year: PropTypes.number,
});

export const userDataPropType = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  birthday: birthdayPropType,
});

export const profilePropType = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  birthday: birthdayPropType.isRequired,
});

const namesPropType = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
});

export const directLinkInfoPropType = PropTypes.shape({
  inviterData: namesPropType.isRequired,
  inviteeData: userDataPropType.isRequired,
  status: PropTypes.string.isRequired,
});

export const shareableLinkInfoPropType = PropTypes.shape({
  inviterData: namesPropType.isRequired,
});

export const invitationTypePropType = PropTypes.oneOf(Object.values(INVITATION_TYPES));

export const classesPropType = PropTypes.shape({});
